import { render, staticRenderFns } from "./UploadFileDialog.vue?vue&type=template&id=14cc8479&scoped=true"
import script from "@/views/Users/Student/Progress/UploadFileDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Progress/UploadFileDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/Progress/upload-file-dialog.scss?vue&type=style&index=0&id=14cc8479&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cc8479",
  null
  
)

export default component.exports